import React from 'react'

type Props = JSX.IntrinsicElements['input'] & {
  hasError: boolean
  classNameOnError: string
}
export const MBInput: React.VFC<Props> = (props) => {
  const {hasError, classNameOnError, className, ...rest} = props
  return (
    <input
      {...rest}
      className={(hasError) ? `${className} ${classNameOnError}` : className}
    >
      {props.children}
    </input>
  )
}
